/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/components/pagination/Pagination.tsx'.
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import RcPagination from 'rc-pagination';
import zhCN from 'rc-pagination/lib/locale/zh_CN';
import warning from 'antd/es/_util/warning';
import { ConfigContext } from '../config-provider';
import { MiniSelect, XsSelect } from './Select';
import { Select } from '../select';
import LocaleReceiver from 'antd/lib/locale-provider/LocaleReceiver';
import useBreakpoint from '../grid/hooks/useBreakpoint';
import { Icon } from '../icon';
const Pagination = ({ prefixCls: customizePrefixCls, selectPrefixCls: customizeSelectPrefixCls, className, size = 'middle', locale: customLocale, ...restProps }) => {
    const { xs, sm, md } = useBreakpoint();
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('pagination', customizePrefixCls);
    if (process.env.NODE_ENV !== 'production')
        warning(restProps.theme !== 'gray', 'Pagination', '`theme` props is deprecated in 3.0.0');
    warning(restProps.bordered !== false, 'Pagination', '`bordered` props is deprecated in 3.0.0');
    const getIconsProps = () => {
        const ellipsis = (React.createElement("span", { className: `${prefixCls}-item-ellipsis` },
            React.createElement(Icon, { type: 'overflow-menu--horizontal' })));
        let prevIcon = (React.createElement("button", { className: `${prefixCls}-item-link`, type: 'button', tabIndex: -1 },
            React.createElement(Icon, { type: 'chevron--left' })));
        let nextIcon = (React.createElement("button", { className: `${prefixCls}-item-link`, type: 'button', tabIndex: -1 },
            React.createElement(Icon, { type: 'chevron--right' })));
        let jumpPrevIcon = (React.createElement("a", { className: `${prefixCls}-item-link` },
            React.createElement("div", { className: `${prefixCls}-item-container` },
                React.createElement(Icon, { type: 'arrow-double--left', className: `${prefixCls}-item-link-icon` }),
                ellipsis)));
        let jumpNextIcon = (React.createElement("a", { className: `${prefixCls}-item-link` },
            React.createElement("div", { className: `${prefixCls}-item-container` },
                React.createElement(Icon, { type: 'arrow-double--right', className: `${prefixCls}-item-link-icon` }),
                ellipsis)));
        // change arrows direction in right-to-left direction
        if (direction === 'rtl') {
            [prevIcon, nextIcon] = [nextIcon, prevIcon];
            [jumpPrevIcon, jumpNextIcon] = [jumpNextIcon, jumpPrevIcon];
        }
        return {
            prevIcon,
            nextIcon,
            jumpPrevIcon,
            jumpNextIcon
        };
    };
    const renderPagination = (contextLocale) => {
        const locale = { ...contextLocale, ...customLocale };
        const isMiddle = size === 'middle' || !!(md && !size && restProps.responsive);
        const isSmall = size === 'small' || !!(sm && !size && restProps.responsive);
        const isXs = size === 'xs' || !!(xs && !size && restProps.responsive);
        const selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
        const extendedClassName = classNames({
            middle: isMiddle,
            small: isSmall,
            xs: isXs,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, className);
        return (React.createElement(RcPagination, { ...restProps, prefixCls: prefixCls, selectPrefixCls: selectPrefixCls, ...getIconsProps(), className: extendedClassName, selectComponentClass: isSmall || isXs ? (isSmall ? MiniSelect : XsSelect) : Select, locale: locale }));
    };
    return (React.createElement(LocaleReceiver, { componentName: 'Pagination', defaultLocale: zhCN }, renderPagination));
};
// export default withConfigProvider(Pagination);
export default Pagination;
